/* A Common Day - size guide dialog.
   Reads window.ACD_SIZE_GUIDE.url, set by snippets/acd-styles.liquid from the
   product metafield custom.size_guide_url. Injects a "Find your size" control
   into the Size option label and opens the chart in a dialog. */
(function () {
  var CFG = window.ACD_SIZE_GUIDE;
  if (!CFG || !CFG.url) return;
  var last = null;
  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1.5" y="7" width="21" height="10" rx="1.6"></rect><path d="M6 7v3M10 7v4.5M14 7v3M18 7v4.5"></path></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"></path></svg>';

  function build() {
    var m = document.getElementById('acd-sg');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'acd-sg';
    m.className = 'acd-sg';
    m.hidden = true;
    m.innerHTML =
      '<div class="acd-sg__scrim" data-close></div>' +
      '<div class="acd-sg__panel" role="dialog" aria-modal="true" aria-labelledby="acd-sg-title">' +
        '<div class="acd-sg__bar">' +
          '<h2 class="acd-sg__title" id="acd-sg-title">Size guide</h2>' +
          '<button type="button" class="acd-sg__close" data-close aria-label="Close size guide">' + CROSS + '</button>' +
        '</div>' +
        '<div class="acd-sg__body">' +
          '<div class="acd-sg__spin"></div>' +
          '<img class="acd-sg__img" alt="Size guide">' +
        '</div>' +
        '<div class="acd-sg__foot">Tap the chart to zoom</div>' +
      '</div>';
    document.body.appendChild(m);

    var body = m.querySelector('.acd-sg__body');
    var img = m.querySelector('.acd-sg__img');
    var spin = m.querySelector('.acd-sg__spin');

    img.addEventListener('load', function () {
      img.classList.add('is-ready');
      spin.hidden = true;
    });
    img.addEventListener('error', function () { spin.hidden = true; });
    img.src = CFG.url;

    img.addEventListener('click', function () {
      body.classList.toggle('is-zoomed');
      if (!body.classList.contains('is-zoomed')) body.scrollTop = 0;
    });

    /* Bind the close button directly. The delegated handler below is the
       backstop for the scrim; it uses closest() rather than an attribute check
       on e.target, because a click on the X lands on the SVG inside the button
       and the SVG carries no data-close of its own. */
    var closeBtn = m.querySelector('.acd-sg__close');
    closeBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });

    m.addEventListener('click', function (e) {
      var hit = e.target && e.target.closest ? e.target.closest('[data-close]') : null;
      if (hit) close();
    });
    return m;
  }

  function open(e) {
    if (e) e.preventDefault();
    last = document.activeElement;
    var m = build();
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var btn = m.querySelector('.acd-sg__close');
    if (btn) btn.focus();
  }

  function close() {
    var m = document.getElementById('acd-sg');
    if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.style.overflow = '';
    var body = m.querySelector('.acd-sg__body');
    if (body) { body.classList.remove('is-zoomed'); body.scrollTop = 0; }
    if (last && last.focus) last.focus();
  }

  document.addEventListener('keydown', function (e) {
    var m = document.getElementById('acd-sg');
    if (!m || m.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var list = m.querySelectorAll('.acd-sg__panel button');
    if (!list.length) return;
    var first = list[0];
    var lastEl = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  });

  function inject(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var sets = scope.querySelectorAll('.variant-input-wrap[data-handle="size"]');
    for (var i = 0; i < sets.length; i++) {
      var wrap = sets[i].closest ? sets[i].closest('.variant-wrapper') : null;
      if (!wrap || wrap.dataset.acdSg) continue;
      var label = wrap.querySelector('label.variant__label');
      if (!label) continue;
      wrap.dataset.acdSg = '1';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'acd-sg-link';
      b.innerHTML = RULER + '<span>Find your size</span>';
      b.addEventListener('click', open);
      label.appendChild(b);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { inject(); });
  } else {
    inject();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType === 1) inject(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();